import { defineMessages } from '@/i18n';

export const inventoryMessages = defineMessages({
  inventoryTitleSeller: 'platform.app.inventory.titleSeller',
  inventoryTitleBuyer: 'platform.app.inventory.titleBuyer',
  inventoryCreateTitle: 'platform.app.inventory.createItem.title',
  inventoryDetailTitle: 'platform.app.inventory.detail.title',
  inventoryEditTitle: 'platform.app.inventory.edit.title',
  createItemLabel: 'platform.app.inventory.createItem.addLabel',
  saveItemLabel: 'platform.app.inventory.edit.saveLabel',
  emptyStateTitleBuyer: 'platform.app.inventory.emptyStateTitleBuyer',
  emptyStateTitleSeller: 'platform.app.inventory.emptyStateTitleSeller',
  emptyStateText: 'platform.app.inventory.emptyStateText',
  emptyStateCta: 'platform.app.inventory.emptyStateCta',
  listingItem: 'platform.app.inventory.listingItem',
  listingPrice: 'platform.app.inventory.listingPrice',
  addItem: 'platform.app.inventory.createItem.title',
  bulkUploadLabel: 'platform.app.inventory.bulkUpload.label',
  edition: 'platform.app.inventory.editionLabel',
  statusSold: 'platform.app.inventory.statusSold',
  myItems: 'platform.app.inventory.myItems',
  sharedWithMe: 'platform.app.inventory.sharedWithMe',
  sharedBy: 'platform.app.inventory.sharedBy',
  sharedWithMeEmptyStateTitle: 'platform.app.inventory.sharedWithMeEmptyStateTitle',
  sharedWithMeEmptyStateSubtitle: 'platform.app.inventory.sharedWithMeEmptyStateSubtitle',
  signatureRequest: 'platform.app.inventory.signatureRequest',
});
